import './Spinner.scss';

import * as React from 'react';

import cx from 'classnames';

interface SpinnerProps {
  size?: 'default' | 'small' | 'medium';
}

export function Spinner({
  size = 'default',
}: SpinnerProps): React.ReactElement {
  const spinnerClass = cx(
    'inline-block rounded-round border-solid border-grey-200 rounded-full',
    'loading-spinner',
    {
      'w-32 h-32': size === 'default',
      'w-7 h-7 border-2': size === 'small',
      'w-26 h-26': size === 'medium',
    }
  );

  return (
    <div className="flex items-center justify-center w-full h-full">
      <div className={spinnerClass} />
    </div>
  );
}
